import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-composition-delete',
  templateUrl: './product-composition-delete.component.html',
  styleUrls: ['./product-composition-delete.component.css']
})
export class ProductCompositionDeleteComponent implements OnInit {

  @Input() deleteId: any;
  @Output() onDeleted = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  productCompositioncList: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleproductCompositionData: any= []
  deleteProductCompositionId:any = ""


  isEditComposition:any = false
  uomData:any = [];
  productName:any = ""
  batchPrice:any = ""
  batchQuantity:any = ""
  isDefault:any = ""
  done:any = [];
  amount:any = 0
  cProductList: any= []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    // this.getAllProductComposition();
    // this.getAllCProduct()
  }

  cancel() {
    this.onCancel.emit();
  }

  delete() {
    if (!this.deleteId) return;
    this.generic_service.deleteProductComposition(this.deleteId).subscribe(
      (res: any) => {
        this.toastr.success("Successfully Deleted");
        this.onDeleted.emit();
      },
      (err: any) => {
        this.toastr.error(err.errors[0].description);
      }
    );
  }

  getAllCProduct(){
    this.generic_service.getAllcProductMaster().subscribe(
      (response:any)=>{
        console.log(response);
        this.cProductList = [];

        for(let i=0; i<response.response.length;i++){
          let body = {
            "name": String(response.response[i].name),
            "qty": 1,
            "uom": "",
            "price": Number(response.response[i].price),
          }
          this.cProductList.push(body)
        }
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllProductComposition();
  }

  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllProductComposition();
  }

  getAllProductComposition(){
    this.generic_service.getAllProductCompositionWithoutPagination().subscribe(
      (response:any)=>{
        console.log(response);
        this.productCompositioncList = response.response
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }


  deleteProduct(id:any){
    this.deleteProductCompositionId = id
  }

  deleteProductComposition(){
    this.generic_service.deleteProductComposition(this.deleteProductCompositionId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductComposition()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}


